import { Card, CardContent, Typography, Button } from "@mui/material";

const plans = [
  { name: "Free", price: "$0", features: ["Basic Features", "Limited Support"] },
  { name: "Basic", price: "$10/mo", features: ["All Free Features", "Priority Support"] },
  { name: "Standard", price: "$20/mo", features: ["All Basic Features", "Advanced Analytics"] },
  { name: "Premium", price: "$50/mo", features: ["All Standard Features", "Dedicated Support"] }
];

export default function SubscriptionCards() {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px", padding: "16px" }}>
      {plans.map((plan) => (
        <Card key={plan.name} style={{ width: "100%", maxWidth: "300px", padding: "16px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
          <CardContent style={{ textAlign: "center" }}>
            <Typography variant="h6" fontWeight="bold">{plan.name}</Typography>
            <Typography variant="h4" fontWeight="semibold" marginY={2}>{plan.price}</Typography>
            <ul style={{ fontSize: "14px", marginBottom: "16px", listStyleType: "none", padding: 0 }}>
              {plan.features.map((feature, index) => (
                <li key={index} style={{ color: "gray" }}>• {feature}</li>
              ))}
            </ul>
            <Button variant="contained" fullWidth>Choose Plan</Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
